import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AppShell } from '@components/layout/AppShell';
import { ThemeProvider } from '@theme/ThemeProvider';
import { queryClient } from '@api/hooks/query-client';
import { DashboardPage } from '@features/dashboard/DashboardPage';
import { UsersListPage } from '@features/users/UsersListPage';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<AppShell />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="users" element={<UsersListPage />} />
              <Route path="superstores" element={<Placeholder title="Superstores" />} />
              <Route path="hubs" element={<Placeholder title="Child Hubs" />} />
              <Route path="service-areas" element={<Placeholder title="Service Areas & Routing" />} />
              <Route path="delivery-slots" element={<Placeholder title="Delivery Slots" />} />
              <Route path="catalogue" element={<Placeholder title="Catalogue" />} />
              <Route path="uom" element={<Placeholder title="UOM & Conversions" />} />
              <Route path="tax" element={<Placeholder title="Tax Master" />} />
              <Route path="suppliers" element={<Placeholder title="Suppliers" />} />
              <Route path="supplier-mappings" element={<Placeholder title="Supplier Mappings" />} />
              <Route path="pricing" element={<Placeholder title="Pricing" />} />
              <Route path="approvals" element={<Placeholder title="Approvals" />} />
              <Route path="bulk-jobs" element={<Placeholder title="Bulk Jobs" />} />
              <Route path="notifications" element={<Placeholder title="Notifications" />} />
              <Route path="settings" element={<Placeholder title="Settings" />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}

function Placeholder({ title }: { title: string }) {
  return (
    <div style={{ padding: 24 }}>
      <h1 style={{ fontSize: 24, fontWeight: 600, color: '#0f172a' }}>{title}</h1>
      <p style={{ color: '#64748b' }}>Implementation in progress.</p>
    </div>
  );
}